
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'FlowDuration',
})
export default class FlowDuration extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  schema: any;

  @Prop({
    type: Object,
    required: true,
  })
  data: any;

  @Prop({
    type: Object,
    required: true,
  })
  value: any;

  allIterations = Array.from({ length: 11 }, (value, key) => key);

  allDays = Array.from({ length: 32 }, (value, key) => key);

  allHours = Array.from({ length: 25 }, (value, key) => key);

  allWeeks = Array.from({ length: 5 }, (value, key) => key);

  allMinutes = Array.from({ length: 61 }, (value, key) => key);

  allMonths = Array.from({ length: 13 }, (value, key) => key);

  updateProperty(property, value) {
    this.$emit('input', {
      ...this.value,
      [property]: value,
    });
  }
}
